import { CustomerDiscountText } from '../../../components/CustomerDiscountText';
import StockIndicator from '../../../components/StockIndicator';
import {
  PriceBreak,
  ProductViewModel,
  TransactionalCurrency,
  Website
} from '../../../types/generated';
import { displayProductWasPrice } from '../../../utilities/displayProductWasPrice';
import formatCurrency from '../../../utilities/formatCurrency';

export interface ProductPricesProps {
  transactionalCurrency: TransactionalCurrency;
  product: ProductViewModel;
  isAdded: boolean;
  showSecondaryPrice: boolean;
  priceBreak: PriceBreak | undefined;
  website: Website;
}

export function ProductPrices({
  transactionalCurrency,
  product,
  showSecondaryPrice
}: ProductPricesProps) {
  const displayWasPrice = displayProductWasPrice(
    product.isContractPrice,
    showSecondaryPrice,
    product.pricingInfo
  );

  function getPrimaryPriceWording() {
    if (displayWasPrice) {
      if (product.isVariant) {
        return 'NOW from ';
      }
      return 'NOW ';
    } else if (product.isVariant) {
      return 'From ';
    }
  }

  return (
    <div className="product-details">
      <CustomerDiscountText
        isVariant={product.isVariant}
        isContractPrice={product.isContractPrice}
        isHeaderDiscounted={product.isHeaderDiscounted}
        styleModifier={'--pdp'}
      />
      <div className="product-details__prices mb-2">
        <div className="product-details__price">
          <div
            className={`product-price product-price--primary ${
              displayWasPrice ? 'product-price product-price--primary-now' : ''
            }`}
          >
            {getPrimaryPriceWording()}
            <span className="d-none">{'GBP'}</span>
            <span className="product-price--primary-value">
              {formatCurrency(
                product.pricingInfo.primaryPrice.value,
                transactionalCurrency
              )}
            </span>
            {!showSecondaryPrice && (
              <span className="price-primary-text">
                {product.pricingInfo.primaryPriceText}
              </span>
            )}
          </div>
          {showSecondaryPrice && (
            <div className={`product-price product-price--secondary`}>
              <span className="d-none">{'GBP'}</span>
              <span>
                {formatCurrency(
                  product.pricingInfo.secondaryPrice.value,
                  transactionalCurrency
                )}
              </span>{' '}
              <span className="price-secondary-text">
                {product.pricingInfo.secondaryPriceText}
              </span>
            </div>
          )}
        </div>
        <div className="product-details__price--additonal-details">
          {displayWasPrice && (
            <div className="product-price product-price__was-price">
              Was{' '}
              {`${product.isVariant ? 'from' : ''} ${formatCurrency(
                product.pricingInfo.primaryWasPrice.value,
                transactionalCurrency
              )}`}
              {!showSecondaryPrice && (
                <span className="price-primary-text">
                  {product.pricingInfo.primaryPriceText}
                </span>
              )}
            </div>
          )}
          {product.pricingInfo.primarySavings > 0 && (
            <span className="savings">
              {product.isVariant || product.hasPriceBreak
                ? 'Savings from '
                : 'Save '}
              {formatCurrency(
                product.pricingInfo.primarySavings,
                transactionalCurrency
              )}
            </span>
          )}
        </div>
      </div>
      {!product.directDelivery && product.stockInfo && (
        <StockIndicator
          stockInfo={product.stockInfo}
          showMessages={true}
          supplierID={product.supplierID}
          isThirdPartyDDelivery={product.isThirdPartyDDelivery}
          isRestricted={product.isRestricted}
        />
      )}
    </div>
  );
}
